import { NgModule, forwardRef }      from '@angular/core';
import { DynamicTypeBuilder }     from './type.builder';
import { DynamicTemplateBuilder } from './template.builder';
import Compute from '../compute.component';
import { ComputeVCDModule } from '../compute-vcd/compute-vcd.module';
import { ComputeVCModule } from '../compute-vc/compute-vc.module';

@NgModule({
    imports:        [ComputeVCModule, ComputeVCDModule],
    declarations:   [Compute],
    exports:        [Compute]
})

export class DynamicComputeModule {

    static forRoot() {
        return {
            ngModule: forwardRef(() => DynamicComputeModule),
            providers: [
                DynamicTemplateBuilder,
                DynamicTypeBuilder
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/compute/dynamic-compute/dynamic-compute.module.ts